import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import SummaryItem from '@/components/view/atoms/summary/SummaryItem'
import SummaryItemList from '@/components/view/atoms/summary/SummaryItemList'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'

interface Props {
  title: string
  // 表示用に整形済みのスコア（例: '+0.35' / '0.50'）
  value: string
  // スコアの単位（例: '/1.00'）
  unit?: string
  valueColor?: TextColor
  // 前回値・変化量（前回結果が無い場合は省略する）
  previous?: string | null
  change?: string | null
}

// 総合スコアのカード。前回結果があれば前回値・変化量も併記する
const GeoScoreCard = ({
  title,
  value,
  unit,
  valueColor = TextColor.PRIMARY,
  previous,
  change
}: Props) => (
  <SummaryItemList shadow>
    <SummaryItem color={'secondary'}>
      <div className='flex flex-col items-center gap-1'>
        <Text size={12} color={TextColor.SECONDARY}>
          {title}
        </Text>
        <ItemAlign gapX={4} align='baseline' nowrap>
          <Text size={32} weight='bold' color={valueColor}>
            {value}
          </Text>
          {unit && (
            <Text size={12} color={TextColor.SECONDARY}>
              {unit}
            </Text>
          )}
        </ItemAlign>
        {(previous != null || change != null) && (
          <ItemAlign gapX={8} align='center' nowrap>
            {previous != null && (
              <ItemAlign gapX={4} align='center' nowrap>
                <Badge size={10} badgeType={BadgeType.SQUARE_TERTIARY}>
                  前回
                </Badge>
                <Text size={12}>{previous}</Text>
              </ItemAlign>
            )}
            {change != null && (
              <ItemAlign gapX={4} align='center' nowrap>
                <Badge size={10} badgeType={BadgeType.SQUARE_TERTIARY}>
                  変化
                </Badge>
                <Text size={12}>{change}</Text>
              </ItemAlign>
            )}
          </ItemAlign>
        )}
      </div>
    </SummaryItem>
  </SummaryItemList>
)

export default GeoScoreCard
